import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { projects, clients } from '../data/sbbData';
import { ChevronRight, ShieldCheck } from 'lucide-react';
import PageHero from '../components/PageHero';

export default function ProjectListing() {
  const { lang, t } = useLanguage();
  const [selectedCat, setSelectedCat] = useState('all');

  const filteredProjects = projects.filter((p) => 
    selectedCat === 'all' || p.category === selectedCat
  );

  return (
    <div className="project-listing-page">
      {/* Page Hero */}
      <PageHero eyebrow="Mahakarya Konstruksi" title={t('nav_projects')} subtitle="Portofolio rekam jejak penyediaan beton siap pakai dan solusi khusus untuk proyek infrastruktur, gedung bertingkat, dan kawasan industri di Indonesia." image="/reference-images/project-cisumdawu.webp" />

      {/* Breadcrumbs */}
      <div className="breadcrumb-wrapper">
        <div className="container">
          <ul className="breadcrumb-list">
            <li><Link to="/">{t('nav_home')}</Link></li>
            <li><span className="separator">/</span></li>
            <li><span className="current">{t('nav_projects')}</span></li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <section className="section">
        <div className="container">
          {/* Category Filter Chips */}
          <div className="filter-chips">
            <button 
              className={`chip-btn ${selectedCat === 'all' ? 'active' : ''}`}
              onClick={() => setSelectedCat('all')}
            >
              {t('filter_all')} Proyek
            </button>
            <button 
              className={`chip-btn ${selectedCat === 'infrastruktur' ? 'active' : ''}`}
              onClick={() => setSelectedCat('infrastruktur')}
            >
              Infrastruktur & Jalan Tol
            </button>
            <button 
              className={`chip-btn ${selectedCat === 'gedung-bertingkat' ? 'active' : ''}`}
              onClick={() => setSelectedCat('gedung-bertingkat')}
            >
              Gedung Bertingkat
            </button>
            <button 
              className={`chip-btn ${selectedCat === 'industri' ? 'active' : ''}`}
              onClick={() => setSelectedCat('industri')}
            >
              Industri & Logistik
            </button>
            <button 
              className={`chip-btn ${selectedCat === 'solusi-teraplikasi' ? 'active' : ''}`}
              onClick={() => setSelectedCat('solusi-teraplikasi')}
            >
              Solusi Teraplikasi
            </button>
          </div>

          {/* Projects Grid */}
          <div className="grid-3">
            {filteredProjects.map((proj) => (
              <div key={proj.slug} className="sbb-card">
                <img src={proj.image} alt={proj.name} className="sbb-card-img" />
                <div className="sbb-card-body">
                  <span className="sbb-card-tag">{proj.location} • {proj.year}</span>
                  <h3 className="sbb-card-title">{proj.name}</h3>
                  <p className="sbb-card-desc">{proj.summary}</p>
                  
                  <div className="project-client-badge">
                    <strong>Klien:</strong> {proj.client}
                  </div>

                  <Link to={`/proyek/${proj.slug}`} className="btn btn-secondary btn-sm" style={{ marginTop: '16px' }}>
                    <span>Lihat Studi Kasus</span>
                    <ChevronRight size={14} />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Trusted By Client Logos Section (Section 5.8) */}
      <section className="section section-subtle">
        <div className="container text-center">
          <span className="accent-bar" style={{ margin: '0 auto 12px auto' }}></span>
          <span className="eyebrow">Kepercayaan Mitra & Kontraktor</span>
          <h2 className="section-title">Dipercaya Oleh Kontraktor Utama Indonesia</h2>

          <div className="client-logos-grid">
            {clients.map((c) => (
              <div key={c.id} className="client-logo-box">
                <ShieldCheck size={20} color="var(--color-brand-primary)" />
                <span>{c.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <style>{`
        .project-client-badge {
          font-size: 12px;
          color: var(--color-text-muted);
          background-color: var(--color-surface-subtle);
          padding: 6px 10px;
          border-radius: 4px;
        }

        .client-logos-grid {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          margin-top: 36px;
        }

        .client-logo-box {
          background-color: #ffffff;
          border: 1px solid var(--color-border);
          border-radius: var(--border-radius-md);
          padding: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          font-size: 13px;
          font-weight: 700;
          color: var(--color-ink);
          box-shadow: var(--shadow-subtle);
        }

        @media (max-width: 768px) {
          .client-logos-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }
      `}</style>
    </div>
  );
}
